import styled, { css } from "styled-components";

export const Input = styled.input`
  width: 100%;

  font-size: 1rem;

  ${({ variant }) =>
    variant === "underline"
      ? css`
          padding: 0.375rem 0.75rem;
          border: none;
          border-bottom: 1px solid #cecece;
          background-color: transparent;

          &:focus-within {
            outline: none;
            border-bottom: 1px solid #3483fa;
          }
        `
      : css`
          padding: 1rem 2rem;
          border-radius: 6px;

          border: 1px solid var(--secondary-color);

          &:focus-within {
            outline: 2px solid var(--secondary-color-opaque);
          }
        `}
`;

export const Label = styled.label`
  display: block;

  width: 100%;
  padding: 0.375rem 0 0.75rem 0;

  color: #cecece;

  font-size: 0.75rem;
  text-align: start;
`;
